import React, { useEffect, useReducer } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button, TableCell, TableRow, Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, Stack, Skeleton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { CacheService } from "../../common/services/cache.service";
import environment from "../../environment/environment";
import APIService from "../../services/api.service";

export function OrderUpdateDialog({row, handleSaveClick, handleCloseClick}: {row: any, handleSaveClick: any, handleCloseClick: any}) {
  const [open, setOpen] = React.useState(true); 
  const [ticStaff, setTicStaff] = React.useState([]); 
  const [form, setForm] = useReducer(
    (form, updates) => ({...form, ...updates}),
    {}
  );

  const statuses = [
    "Submitted",
    "Completed",
    "Working",
    "Cancelled"
  ];
  
  useEffect(() => {
    console.log('row', row);
    const url = `${environment.npgApiUrl}user/getusers?roles=etic_admin&pageSize=20000`;
    const apiService = new APIService<any>(axios, new CacheService, url);

    apiService.getAnyAsync().then((res:any) => {
      console.log('orders', res);
      setTicStaff(res.data);
    });

  }, []);

  const handleChange = (fieldName: string, value: any) => {
    setForm({[fieldName]: value});
  }

  return (
    <div>
      <Dialog open={open}  PaperProps={{ style: { minWidth: "900px" } }}>
        <DialogTitle sx={{ fontWeight: "bolder" }}>Order Info</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: "rgba(63, 66, 66, 0.76)", whiteSpace: "pre-line" }}>
            {
              <>
                <Stack spacing={2} direction="row" sx={{marginBottom: 2, marginTop: 2}}>
                  <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    label="Cust. Name"
                    disabled={true}
                    value={row?.custName}
                    sx={{width: 300}} 
                    size="small"
                    InputLabelProps={{shrink: true}}
                  />

                  <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    label="Cust. Email"
                    disabled={true}
                    value={row?.email}
                    sx={{width: 300}} 
                    size="small"
                    InputLabelProps={{shrink: true}}
                  />      

                  <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    label="Status"
                    disabled={true}
                    value={row?.status}
                    sx={{width: 150}} 
                    size="small"
                    InputLabelProps={{shrink: true}}
                  />      

                  <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    label="Date"
                    disabled={true}
                    value={row?.date}
                    sx={{width: 150}} 
                    size="small"
                    InputLabelProps={{shrink: true}}
                  />      
                </Stack>

                <Stack spacing={2} direction="row" sx={{marginBottom: 2, marginTop: 2}}>
                  <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    label="Staff Name"
                    disabled={true}
                    value={row?.staffName}
                    sx={{width: 200}} 
                    size="small"
                    InputLabelProps={{shrink: true}}
                  />

                  <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    label="Staff Email"
                    disabled={true}
                    value={row?.staffEmail}
                    sx={{width: 200}} 
                    size="small"
                    InputLabelProps={{shrink: true}}
                  />      
                </Stack>

                <h2>Update Order</h2>

                  <TextField
                    type="text"
                    variant='outlined'
                    color='primary'
                    label="Tic Staff"
                    onChange={e => handleChange('staffId', e.target.value)}
                    value={form?.staffName}
                    sx={{width: 300}} 
                    size="small"
                    required
                    select>
                    {ticStaff.map((user) => (
                      <MenuItem key={user.userId} value={user.userId}>
                        {user?.firstName + ' ' + user?.lastName}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    type="text"
                    variant='outlined'
                    color='primary'
                    label="Status"
                    onChange={e => handleChange('status', e.target.value)}
                    value={form?.status}
                    sx={{width: 200}} 
                    size="small"
                    required
                    select>
                    {statuses.map((status) => (
                      <MenuItem key={status} value={status}>
                        {status}
                      </MenuItem>
                    ))}
                  </TextField>
              </> 
              
            }
            
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            id="secondary" 
            variant="outlined" 
            startIcon={<FontAwesomeIcon icon={["fas", "circle-x"]} />}
            onClick={handleCloseClick}>
              Cancel
          </Button>

          <Button
            id="secondary" 
            variant="outlined" 
            startIcon={<FontAwesomeIcon icon={["fas", "save"]} />}
            disabled={!form?.status}
            onClick={(e) => handleSaveClick(form, row)}>
              Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
